import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import CandidatoService from '../../services/Candidato';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Toast from '../../components/Toast/Toast';
import Loading from '../../components/Loading/Loading';
import { ButtonSecondary } from '../../components/Button/Button';

import DadosCandidato from '../../forms/Recibo/DadosCandidato';
import DadosEscola from '../../forms/Recibo/DadosEscola';
import DadosEndereco from '../../forms/Recibo/DadosEndereco';
import DadosInscricao from '../../forms/Recibo/DadosInscricao';
import { ButtonExport } from '../../forms/Buttons/ButtonsExport';

import { locationCandidatoParse } from '../../helper/ParseStateHelper';

import { getEdicaoCompleta } from '../../helper/ContextHelper';

import { patternEnum } from '../../variables/Enums/Enum';

import { Layout } from '../../layouts/private/Private';

import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  printContainer: {
    '@media print': {
      padding: '0 !important',
      margin: '0 !important',
      width: '100% !important',
      '& .MuiTypography-h6': {
        fontSize: '1.0rem !important',
        marginBottom: theme.spacing(1),
      },
    },
  },
  headerInfo: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    borderBottom: '2px solid #333',
    paddingBottom: theme.spacing(1),
    '@media print': {
      marginBottom: theme.spacing(1),
    }
  }
});

export class Candidato extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      setOpen: this.setOpen,
      inscricao: {
        codigo: '',
        dataFinalizacaoInscricao: '',
        localProva: {
          municipio: '',
          uf: '',
        },
        localProvaConfirmado: {
          municipio: '',
          uf: '',
          dataConfirmacao: '',
        },
        podeGerarRecibo: false,
        precisaRealizarPagamento: false,
        valorPagar: 0,
      },
      candidato: {
        nome: '',
        nomeSocial: '',
        nomeExibicao: '',
        cpf: '',
        sexo: '',
        raca: '',
        dataNascimento: '',
        email: '',
        necessidadeEspecial: '',
        descricaoOutrasDeficiencias: '',
        anoLetivo: '',
        dataInicioInscricao: '',
      },
      telefonePrincipal: {
        ddd: '',
        telefone: '',
      },
      telefoneAlternativo: {
        ddd: '',
        telefone: '',
      },
      escola: {
        inep: '',
        nome: '',
        dependenciaAdministrativa: '',
      },
      endereco: {
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        municipio: '',
        uf: '',
      },
      optionsSexo: [],
      optionsRaca: [],
      optionsNecessidadeEspecial: [],
      optionsAnoLetivo: [],
      optionsDependenciaAdministrativa: [],
    }
  }

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;

  // EXPORTAR PDF
  handleExportChange = async () => {
    const { open, setOpen } = this.context;
    if (open) await setOpen(!open);
    window.print();
  }

  async componentDidMount() {
    const racas = await EnumService.listarRacas().then(res => res.data);
    const sexos = await EnumService.listarSexos().then(res => res.data);
    const necessidadesEspeciais = await EnumService.listarNecessidadesEspeciais().then(res => res.data);
    const anosLetivos = await EnumService.listarAnosLetivos().then(res => res.data);
    const dependenciasAdministrativas = await EnumService.listarDependenciasAdministrativas().then(res => res.data);

    this.setState({
        ...this.state,
        optionsRaca: [...racas],
        optionsSexo: [...sexos],
        optionsNecessidadeEspecial: [...necessidadesEspeciais],
        optionsAnoLetivo: [...anosLetivos],
        optionsDependenciaAdministrativa: [...dependenciasAdministrativas],
    });

    this.props.loadPeriodos();

    const f = locationCandidatoParse(this.props.location);
    const id = this.props.match.params.id ?? f.find(f => f.field === 'id').value;

    await CandidatoService.find(id)
      .then(res => {
        this.setState({
          inscricao: {
            codigo: res.data.codigo,
            dataFinalizacaoInscricao: res.data.dataFinalizacaoInscricao,
            localProva: {
              municipio: res.data.localProvaOriginal.nome,
              uf: res.data.localProvaOriginal.uf.id,
            },
            localProvaConfirmado: {
              municipio: res.data.localProvaFinal.nome,
              uf: res.data.localProvaFinal.uf.id,
              dataConfirmacao: res.data.dataConfirmacaoLocalProvaFinal,
            },
            podeGerarRecibo: res.data.podeGerarRecibo,
            precisaRealizarPagamento: res.data.precisaRealizarPagamento,
          },
          candidato: {
            nome: res.data.nome,
            nomeSocial: res.data.nomeSocial,
            nomeExibicao: res.data.nomeExibicao,
            cpf: res.data.cpf,
            sexo: patternEnum(res.data.sexo, sexos),
            raca: patternEnum(res.data.raca, racas),
            dataNascimento: res.data.dataNascimento,
            email: res.data.email,
            necessidadeEspecial: res.data.necessidadeEspecial ? patternEnum(res.data.necessidadeEspecial, necessidadesEspeciais) : '',
            descricaoOutrasDeficiencias: res.data.descricaoOutrasDeficiencias,
          },
          telefonePrincipal: {
            ddd: res.data.telefonePrincipal.ddd,
            telefone: res.data.telefonePrincipal.fone,
          },
          telefoneAlternativo: {
            ddd: res.data.telefoneAlternativo?.ddd ?? '',
            telefone: res.data.telefoneAlternativo?.fone ?? '',
          },
          escola: {
            inep: res.data.escola?.inep ?? '',
            nome: res.data.escola?.nome ?? '',
            anosLetivos: res.data.escola ? res.data.anosLetivos.map(ano => patternEnum(ano, anosLetivos)).join(', ') : '',
            dependenciaAdministrativa: res.data.escola ? patternEnum(res.data.escola.dependenciaAdministrativa, dependenciasAdministrativas) : '',
          },
          endereco: {
            cep: res.data.endereco.cep,
            endereco: res.data.endereco.endereco,
            numero: res.data.endereco.numero,
            complemento: res.data.endereco.complemento,
            bairro: res.data.endereco.bairro,
            municipio: res.data.endereco.municipio.nome,
            uf: res.data.endereco.municipio.uf.id,
          }
        })
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })
      .finally(() => this.setState({ loading: false, }));
  }

  render () {
    const { classes } = this.props;
    
    const pageName = 'Comprovante de Inscrição';
    const links = [];

    return (
      <Layout>
        <div className={classes.printContainer}>
          <Toast parentRef={this.setToast} />
          <Grid className="no-print" container>
            <Grid item xs={12}>
              <Breadcrumbs links={links} active={pageName} />
            </Grid>
          </Grid>
          
          { this.state.loading ? 
            <Loading />
          :
            <div style={{ padding: '16px 16px 0' }}>
              <div className={classes.headerInfo}>
                <Typography variant="h6" style={{ fontWeight: 600, color: '#000' }}>
                  {pageName.toUpperCase()}
                </Typography>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  {this.props.contexts && getEdicaoCompleta(this.props.contexts)}
                </Typography>
              </div>

              <Typography variant="h6" style={{ marginBottom: 8 }}>
                <b>{this.state.candidato.nomeExibicao}</b>
              </Typography>

              <DadosCandidato candidato={this.state.candidato} telefonePrincipal={this.state.telefonePrincipal} telefoneAlternativo={this.state.telefoneAlternativo} />
              <DadosInscricao inscricao={this.state.inscricao} />
              {this.state.escola &&
                <DadosEscola escola={this.state.escola} />
              }
              <DadosEndereco endereco={this.state.endereco}/>            
            </div>
          }
          
          <div style={{ paddingLeft: 16 }}>
            <Grid className="no-print" container spacing={3} alignItems='flex-end' style={{ marginTop: 16 }}>
              <Grid item sm={12} lg={12}>
                { this.state.inscricao.podeGerarRecibo &&
                  <ButtonExport 
                    title="Exportar PDF"
                    onClick={this.handleExportChange} 
                  />
                }
                <ButtonSecondary
                  startIcon={<ArrowBackIcon />}
                  style={{ marginTop: 4 }}
                  onClick={this.props.history.goBack}
                  name={"Voltar"}
                />
              </Grid>   
            </Grid>
          </div>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(Candidato)));